import { SplashScreen } from '@aibees/shared/components';
import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import {
  AUTH_CLIENT_ID,
  AUTH_REDIRECT_URL,
  AUTH_URL,
  PATH_AFTER_LOGIN,
} from '../constants';
import { AuthContext } from './context';

const MAX_STATE_LENGTH = 1500;

export function AuthConsumer({
  children,
  logoSrc,
}: PropsWithChildren & { logoSrc?: string }) {
  const { pathname, search } = useLocation();

  const redirectToLoginPage = () => {
    setTimeout(() => {
      // Use the full path as-is (just URL encode it)
      const fullPath = `${pathname}${search}`;

      // Check if the encoded state would be too long (Cloudflare limits)
      const encodedFullPath = encodeURIComponent(fullPath);
      const statePath =
        encodedFullPath.length > MAX_STATE_LENGTH ? PATH_AFTER_LOGIN : fullPath;

      // Build OAuth URL with state parameter containing after_login path
      const encodedRedirectUri = encodeURIComponent(AUTH_REDIRECT_URL);
      const encodedState = encodeURIComponent(statePath);

      window.location.href = `${AUTH_URL}/auth?response_type=code&scope=openid&client_id=${AUTH_CLIENT_ID}&redirect_uri=${encodedRedirectUri}&state=${encodedState}`;
    }, 100);
  };

  return (
    <AuthContext.Consumer>
      {(auth) =>
        auth.loading ? (
          <>
            {!auth.token && redirectToLoginPage()}
            <SplashScreen logoSrc={logoSrc} />
          </>
        ) : (
          children
        )
      }
    </AuthContext.Consumer>
  );
}
